import React, { lazy } from "react";

import { ClientOnly } from "@/utils/client-only.tsx";

const DirectBuySiteSetupContainer = lazy(
    () =>
        // @ts-ignore
        import(
            "../../../../../components/signup/post-order/src/layout/direct-buy-site-setup-container.tsx"
        )
);

export const BuyCloudSiteSetupPageTemplate: React.FC = () => {
    return (
        <ClientOnly>
            <DirectBuySiteSetupContainer />
        </ClientOnly>
    );
};
